import {  Empty, Grid, Skeleton, Space, Switch, Table,  Tooltip } from 'antd';
import { Column,} from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import { Event } from 'types/event';
import { useSetting } from 'features/cms/use-cases/get-setting';

const { useBreakpoint } = Grid;
type SettingTableProps = {
    data: any[];
    isLoading: boolean;
};
export const SettingTabel = ({ data, isLoading }: SettingTableProps) => {
    const screens = useBreakpoint();

    const { mutate: mutateUpdateItem, isLoading: isLoadingUpdate } =
        useSetting();
 
return (
        <>


            <StyledTableWrapper>
                <StyledTableHeader style={{ fontSize: '18px', fontWeight: '500' }}>
                    Setting
                </StyledTableHeader>
                <Table<Event>
                    className="cstltblwthldr"
                    locale={{
                        emptyText: isLoading  ? <Skeleton active={true} /> : <Empty />
                    }}
                    dataSource={isLoading ? [] : data}
                    loading={isLoading && { indicator: <div><TableLoader /></div> }}
                    rowKey='id'
                    pagination={false}
                >
                    {/* <Column<Event>
                        title={'ID'}
                        dataIndex={'id'}
                    /> */}
                    <Column<any>
                        title={'Tab Name'}
                        dataIndex={'tabName'}
                    />

                    <Column<Event>
                        title={"Action"}
                        width={screens.xxl ? 'auto' : 162}
                        dataIndex={'is_active'}
                        render={(_, record) => (
                            <>
                                <Space>
                                    <Tooltip title="Is Active">
                                        <Switch
                                            defaultChecked={record.status}
                                            checked={record.status}
                                            loading={isLoadingUpdate}
                                            onChange={(isChecked) => {
                                                mutateUpdateItem({
                                                    id: record.id,
                                                    flag: "updatestatus",
                                                    status: isChecked,
                                                });
              
                                                record.status = isChecked;
                                            }}

                                        />
                                    </Tooltip>
                                </Space>
                            </>
                        )}
                    />
                </Table>
            </StyledTableWrapper>
        </>

    );
};

